<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>招接待宾馆预约系统</el-breadcrumb-item>
        <el-breadcrumb-item>宾馆基本信息</el-breadcrumb-item>
        <el-breadcrumb-item>信息编辑</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <div>
        <el-form v-loading="formLoading" ref="commodityForm" :model="listParams" :rules="checkListParams" label-width="150px">
          <el-form-item label="宾馆名称：">
            {{ listParams.name }}
          </el-form-item>

          <el-form-item label="宾馆地址：">
            {{ listParams.address }}
          </el-form-item>

          <el-form-item label="联系电话：">
            {{ listParams.tel }}
          </el-form-item>

          <el-form-item label="宾馆图片：">
            <div class="wrap-thumbnail-img" v-if="listParams.pictures.length > 0">
              <div class="thumbnail-img" v-for="(item, index) in listParams.pictures" :key="index">
                <div class="combined-img">
                  <img :src="item" alt="" class="thumbnail-img-wrapped" :key="index" />
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item class="align-center" style="padding-bottom: 20px; margin-top: 30px" id="backButton">
            <el-button size="small" @click="backToList">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formLoading: false,
      listParams: {},
    };
  },
  mounted() {
    this.loadDetailPage(this.$route.query.id);
  },
  methods: {
    loadDetailPage(id) {
      this.formLoading = true;
      this.$http({
        url: global.apiUrl + "/reception/hotel/detail?hotelId=" + id,
        method: "GET",
      })
        .then(res => {
          this.formLoading = false;
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              const data = res.body.data.hotel;
              this.listParams = data;
            } else {
            }
          }
        })
        .catch(err => {
          this.formLoading = false;

          console.error(err);
        });
    },
    backToList() {
      this.$router.push({
        name: "roomManagement",
      });
    },
  },
};
</script>

<style lang="less" scoped>
#backButton .el-form-item__content {
  margin-left: 0 !important;
}
.hx-form-container {
  .wang-editor-style {
    height: 600px;

    .wang-editor-body {
      height: 540px;
    }
  }
  .upload-thumbnail-img,
  .thumbnail-img {
    width: 100px;
    height: 50px;
    border: 1px solid #ebeef5;
    position: relative;
    overflow: hidden;
    margin-left: 10px;
    .upload-icon {
      font-size: 20px;
      display: inline-block;
      margin-top: 15px;
      margin-left: 40px;
    }
    .hidden-upload {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      filter: alpha(opacity=0); //filter 过滤器   兼容IE678
      z-index: 2;
      cursor: pointer;
    }
    .thumbnail-img-wrapped {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .combined-img {
      position: relative;
      width: 100px;
      height: 50px;
      .hover-img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 999;
        opacity: 0;
        .close-btn {
          font-size: 22px;
          color: #fff;
          position: absolute;
          left: 50%;
          margin-left: -11px;
          top: 50%;
          margin-top: -11px;
        }
      }
      .hover-img:hover {
        opacity: 1;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  }
  .wrap-thumbnail-img {
    width: 100%;
    height: 50px;
    margin-top: 10px;
    display: flex;
  }
}
</style>
